import { createSelector } from 'reselect';

const issueState = (state) => state.issue;

export const itemsIssueSelector = createSelector(issueState, (issue) => issue.items);
export const selectedItemIssueSelector = createSelector(issueState, (issue) => issue.selectedItem);
export const searchValueIssueSelector = createSelector(issueState, (issue) => issue.searchValue);
export const sortSelectedItemIssueSelector = createSelector(issueState, (issue) => issue.sortSelectedItem);
export const sortItemsIssueSelector = createSelector([itemsIssueSelector, sortSelectedItemIssueSelector, searchValueIssueSelector], (items, sortSelectedItem, searchValue) => {
    const compareFn = (a, b) => {
        switch (sortSelectedItem.name) {
            case 'transport_number':
                switch (sortSelectedItem.order) {
                    case 'ASC':
                        return b.transport_number === null ? -1 : a.transport_number === null ? 1 : a.transport_number.localeCompare(b.transport_number, { sensitivity: 'base' });
                    case 'DESC':
                        return b.transport_number === null ? -1 : a.transport_number === null ? 1 : b.transport_number.localeCompare(a.transport_number, { sensitivity: 'base' });
                }
                break;
            case 'created_at':
                switch (sortSelectedItem.order) {
                    case 'ASC':
                        return moment(a[sortSelectedItem.name]) - moment(b[sortSelectedItem.name]);
                    case 'DESC':
                        return moment(b[sortSelectedItem.name]) - moment(a[sortSelectedItem.name]);
                }
                break;
            case 'status':
                switch (sortSelectedItem.order) {
                    case 'ASC':
                        return a.status.localeCompare(b.status, {
                            sensitivity: 'base',
                        });
                    case 'DESC':
                        return b.status.localeCompare(a.status, {
                            sensitivity: 'base',
                        });
                }
                break;
            default:
                switch (typeof a[sortSelectedItem.name]) {
                    case 'string':
                        switch (sortSelectedItem.order) {
                            case 'ASC':
                                return a.title.localeCompare(b.title, {
                                    sensitivity: 'base',
                                });
                            case 'DESC':
                                return b.title.localeCompare(a.title, {
                                    sensitivity: 'base',
                                });
                        }
                        break;
                    case 'number':
                        switch (sortSelectedItem.order) {
                            case 'ASC':
                                return a[sortSelectedItem.name] - b[sortSelectedItem.name];
                            case 'DESC':
                                return b[sortSelectedItem.name] - a[sortSelectedItem.name];
                        }
                        break;
                }
        }
    };

    if (searchValue.length) {
        return items.filter((item) => item.title.indexOf(searchValue) !== -1).sort(compareFn);
    }

    return items.sort(compareFn);
});
